import { useEffect, useState } from 'react';

function GlivePage() {
  const [isVisible, setIsVisible] = useState(false);
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const revealTimer = window.setTimeout(() => setIsVisible(true), 80);
    const dotTimer = window.setInterval(() => setDotCount((count) => (count + 1) % 4), 600);

    return () => {
      window.clearTimeout(revealTimer);
      window.clearInterval(dotTimer);
    };
  }, []);

  return (
    <section className="relative isolate flex h-[100dvh] items-center justify-center overflow-hidden bg-[#151515] px-5 py-16 text-white sm:px-10">
      <div
        className="glive-grid pointer-events-none absolute inset-0 opacity-40"
        aria-hidden="true"
      />

      <div
        className={`relative z-10 flex w-full max-w-[30rem] flex-col items-center gap-7 text-center transition-all duration-700 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
        }`}
      >
        <div className="flex items-center gap-2 rounded-full border border-primary/50 bg-black/40 px-4 py-1.5 backdrop-blur-sm">
          <span className="size-2 rounded-full bg-primary shadow-[0_0_12px_var(--primary)] motion-safe:animate-pulse" />
          <span className="font-mono text-[0.7rem] font-bold tracking-[0.28em] text-primary">
            LIVE NOW
          </span>
        </div>

        <div className="relative flex size-40 items-center justify-center sm:size-48">
          <div className="absolute inset-2 rounded-full border border-primary/40 motion-safe:animate-[glive-spin_8s_linear_infinite]" />
          <div className="absolute inset-6 rounded-full border-2 border-dashed border-primary/25 motion-safe:animate-[glive-spin_12s_linear_infinite_reverse]" />
          <span className="relative font-sans text-[8rem] font-bold leading-none text-transparent [-webkit-text-stroke:2px_#ffc800] sm:text-[9.5rem]">
            G
          </span>
        </div>

        <div>
          <p className="mb-2 font-mono text-base tracking-[0.35em] text-white/45">WELCOME TO</p>
          <h1 className="text-[3.3rem] font-bold tracking-[0.12em] text-white">Hello G Live</h1>
        </div>

        <div className="h-px w-full max-w-xs overflow-hidden bg-white/10">
          <div className="glive-scan h-full w-2/5 bg-primary" />
        </div>

        <p className="font-mono text-xs tracking-[0.15em] text-primary/75">
          STREAM INITIALIZING{'.'.repeat(dotCount)}
        </p>
      </div>
    </section>
  );
}

export default GlivePage;
